module.exports = __webpack_public_path__ + "files/77cf5cbae7a2848fe077b51689ce66ee.svg";